import type { CapiPlp, DirectProductListItem } from 'types/capi/plp';

import usePageData from '~/hooks/usePageData';
import useQsParams from '~/hooks/useQsParams';

import DirectProductCard from './DirectProductCard';

function getProductChunks(
  [...products]: DirectProductListItem[],
  chunkSize: number
) {
  const chunks = [];

  while (products.length) chunks.push(products.splice(0, chunkSize));

  return chunks;
}

type CarouselProps = {
  numberVisible: number;
  products: DirectProductListItem[];
};

const Carousel = ({ products, numberVisible }: CarouselProps) => {
  return (
    <div className="custom-scrollbar flex w-full gap-2 overflow-x-scroll pb-6 md:gap-6">
      {getProductChunks(products, numberVisible).map((chunk, chunkIndex) => (
        <div
          key={`products-chunk-${chunkIndex}`}
          style={{
            gridTemplateColumns: `repeat(${chunk.length}, minmax(0, 1fr))`,
            width: `${(chunk.length / numberVisible) * 95}%`
          }}
          className={`grid shrink-0 gap-2 md:gap-6 ${chunk.length === 1 ? 'px-[2px] md:px-2' : ''}`}
        >
          {chunk.map((product, productIndex) => (
            <DirectProductCard
              key={`product-${productIndex}`}
              product={product}
              padImage
              className="w-full"
              imageLoading="eager"
              cardSize="small"
              pagePosition="PLP Direct Carousel"
            />
          ))}
        </div>
      ))}
    </div>
  );
};

const Title = () => {
  const { q } = useQsParams();

  return (
    <div className="flex w-full flex-col gap-2">
      <div className="flex flex-col">
        <div className="justify-start text-left text-lg">
          More results for “{q}” from our retail partners
        </div>
        <div className="text-xs">Tap to buy now!</div>
      </div>
    </div>
  );
};

const DirectProductsCarousel = () => {
  const { direct_products } = usePageData<CapiPlp>();

  const filtered = direct_products?.filter((product) => !!product.affiliate);

  if (!filtered) return null;

  return (
    <div className="relative col-span-full w-full bg-grey-panel-dark md:py-4">
      <div className="mx-auto flex h-fit max-w-desktop flex-col justify-start gap-6 px-6 py-4 md:py-4">
        <Title />
        <div className="hidden md:block">
          <Carousel products={filtered} numberVisible={4} />
        </div>
        <div className="md:hidden">
          <Carousel products={filtered} numberVisible={2} />
        </div>
      </div>
    </div>
  );
};

export default DirectProductsCarousel;
